import styles from "./ContactItem.module.css";

const hrefUrl = (name, contact = "") => {
  if (name === "Contact Me") {
    return `tel:${contact}`;
  } else if (name === "Email") {
    return `mailto:${contact}`;
  } else if (name === "WhatsApp") {
    return `https://wa.me/970597859389`;
  }
  return "";
};

export const ContactItem = ({ Icon, title, subtitle }) => {
  const herf = hrefUrl(title, subtitle);
  return (
    <div className={styles.content}>
      <Icon className={styles.icon} />
      <div>
        <a target={herf && "_blank"} className={styles.link} href={herf}>
          <h3 className={styles.title}>{title}</h3>
          {subtitle}
        </a>
      </div>
    </div>
  );
};
